import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMockVehicleDetail } from "../../data";
import {
  selectFilteredVehicles,
  selectVehicleStatusesLoading,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import { VehicleTableRow } from "../../types";
import { useStyles } from "./styles";

const EMPTY_TABLE_VALUE = "-";

const statusValue = (t: (key: string) => string, value: string) =>
  value ? t(`VECHILE_STATUS.STATUS_VALUES.${value}`) : EMPTY_TABLE_VALUE;

const VehicleTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const vehicles = useSelector(selectFilteredVehicles);
  const loading = useSelector(selectVehicleStatusesLoading);

  const handleRowClick = (row: VehicleTableRow) => {
    dispatch(
      actions.getVehicleDetailSuccess({
        vehicleId: row.id,
        detail: getMockVehicleDetail(row),
      })
    );
  };

  const columns = useMemo(() => {
    return [
      {
        id: "tl",
        label: t("VECHILE_STATUS.TABLE.SIGNATURES"),
        minWidth: 90,
        align: "right",
        format: (row) => statusValue(t, row.tl),
      },
      { id: "plannedFinish", label: t("VECHILE_STATUS.TABLE.PLANNED_FINISH"), minWidth: 120, align: "right" },
      {
        id: "approvals",
        label: t("VECHILE_STATUS.TABLE.APPROVALS"),
        minWidth: 90,
        align: "right",
        format: (row) => statusValue(t, row.approvals),
      },
      {
        id: "curtainStatus",
        label: t("VECHILE_STATUS.TABLE.CURTAIN"),
        minWidth: 80,
        align: "right",
        format: (row) => statusValue(t, row.curtainStatus),
      },
      {
        id: "hydraulicTailgate",
        label: t("VECHILE_STATUS.TABLE.HYDRAULIC_SIDE"),
        minWidth: 130,
        align: "right",
        format: (row) => statusValue(t, row.hydraulicTailgate),
      },
      {
        id: "floor",
        label: t("VECHILE_STATUS.TABLE.FLOOR"),
        minWidth: 80,
        align: "right",
        format: (row) => statusValue(t, row.floor),
      },
      {
        id: "productionStatus",
        label: t("VECHILE_STATUS.TABLE.PRODUCTION_STATUS"),
        minWidth: 130,
        align: "right",
        format: (row) => statusValue(t, row.productionStatus),
      },
      {
        id: "vehicleType",
        label: t("VECHILE_STATUS.TABLE.YARD_VEHICLE_TYPE"),
        minWidth: 100,
        align: "right",
        format: (row) => statusValue(t, row.vehicleType),
      },
      {
        id: "manufacturer",
        label: t("VECHILE_STATUS.TABLE.MANUFACTURER"),
        minWidth: 90,
        align: "right",
        format: (row) => statusValue(t, row.manufacturer),
      },
      {
        id: "model",
        label: t("VECHILE_STATUS.TABLE.MODEL"),
        minWidth: 80,
        align: "right",
        format: (row) => statusValue(t, row.model),
      },
      { id: "workOrderNo", label: t("VECHILE_STATUS.TABLE.WORK_ORDER_NO"), minWidth: 140, align: "right" },
      { id: "chassisNo", label: t("VECHILE_STATUS.TABLE.CHASSIS_NO"), minWidth: 110, align: "right" },
      {
        id: "customerName",
        label: t("VECHILE_STATUS.TABLE.CLIENT_NAME"),
        minWidth: 120,
        align: "right",
        format: (row) => statusValue(t, row.customerName),
      },
      {
        id: "officeStatus",
        label: t("VECHILE_STATUS.TABLE.OFFICE_STATUS"),
        minWidth: 110,
        align: "right",
        format: (row) => statusValue(t, row.officeStatus),
      },
      { id: "entryDate", label: t("VECHILE_STATUS.TABLE.ENTRY_TO_YARD"), minWidth: 150, align: "right" },
    ];
  }, [t]);

  return (
    <div className={styles.root}>
      <DataTable
        rows={vehicles}
        columns={columns}
        loading={loading}
        serialEnabled={false}
        onRowClick={handleRowClick}
        isPointerCursor
      />
    </div>
  );
};

export default VehicleTable;
